/**
 * Menu script
 */
class TJ_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menu = this.menuWrapper.find('.menu-block');
    }

    initEvents() {
        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.win.scrollTop() > 0) {
          this.menuWrapper.addClass('is-fixed');
        }

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                this.menu.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                $(document.body).toggleClass('no-scroll');

                setTimeout(() => {
                    this.menu.toggleClass('is-showing');
                }, 150);
            });
        }

        $('#menu-main a').on('click', e => {
          this.menu.removeClass('is-active');
          this.menuIcon.removeClass('is-active');
          $(document.body).removeClass('no-scroll');
          this.menu.removeClass('is-showing');
        });
    }
}
